import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Box, Typography, Button } from '@mui/material';
import ReactLoading from 'react-loading';

import DisputesDetails from './DisputesDetails';
import DisputesAction from './DisputesAction';
import Page from '../../Page';
import Alert from '../../../ui/Alert';

import { fetchSessionLots } from '../../../modules/reports/thunks';
import { CLEAR_DISPUTES_DATA } from '../../../modules/reports/reducer';

const OpenDisputes = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { state = {} } = useLocation();

  const { houseRef } = useSelector(state => state.house);
  const sessionLotsLoading = useSelector(state => state.reports.sessionLotsLoading);
  const submitDisputeResult = useSelector(state => state.reports.submitDisputeResult) || {};

  const isMessageSend = submitDisputeResult.success === 'true';
  const { sessionIds, selectedRefs } = state;
  const hasValidState = Boolean(sessionIds?.length);

  useEffect(() => {
    if (houseRef && hasValidState) dispatch(fetchSessionLots(houseRef, sessionIds));

    return () => {
      dispatch({
        type: CLEAR_DISPUTES_DATA
      });
    };
  }, [houseRef, sessionIds, hasValidState]);

  return (
    <Page
      header={{ title: 'Open New File' }}
    >
      {hasValidState ? (
        <Container disableGutters maxWidth={false}>
          {!houseRef || sessionLotsLoading ? (
            <ReactLoading className="loading-spinner" type="spin" color="black" />
          ) : (
            <Box>
              {isMessageSend ? (
                <Box>
                  <Alert color="primary" className="mb-3">
                    Your dispute(s) or return(s) have been initiated. Mutual resolutions will be
                    resolved within 5 minutes.
                  </Alert>
                  <Button
                    variant="text"
                    color="secondary"
                    onClick={() => history.push('/reports/sessionResults/viewSessionResults', selectedRefs ? { selectedRefs } : undefined)}
                  >
                    « Go Back to Sale Results
                  </Button>
                </Box>
              ) : (
                <>
                  <DisputesDetails />
                  <DisputesAction houseRef={houseRef} selectedRefs={selectedRefs} />
                </>
              )}
            </Box>
          )}
        </Container>
      ) : (
        <Box>
          <Typography variant="body2">
            There are no transactions for this session.{' '}
            <Button
              variant="text"
              color="secondary"
              onClick={() => history.push('/reports/sessionResults', { selectedRefs })}
            >
              Please Go Back to Sale Results
            </Button>
          </Typography>
        </Box>
      )}
    </Page>
  );
};

export default OpenDisputes;
